"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UIDeviceFrame = _interopRequireDefault(require("UIComponents/device/UIDeviceFrame"));

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _DynoEditorDemoIframe = _interopRequireDefault(require("lead-flows-ui/components/editor/DynoEditorDemoIframe"));

var _DynoPreviewCarouselSteps = _interopRequireDefault(require("./DynoPreviewCarouselSteps"));

var CAROUSEL_INTERVAL = 4000;
var stepInterval;

var _default = _react.default.createClass({
  displayName: "DynoSidePreview",
  propTypes: {
    dyno: _react.default.PropTypes.object.isRequired,
    interactionDisabled: _react.default.PropTypes.bool,
    state: _react.default.PropTypes.string.isRequired,
    step: _react.default.PropTypes.string.isRequired,
    hasForm: _react.default.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      interactionDisabled: true
    };
  },
  getInitialState: function getInitialState() {
    return {
      carouselStep: this.props.state,
      carouselStopped: false,
      gdprStep: 0
    };
  },
  componentDidMount: function componentDidMount() {
    this.setUpInterval();
  },
  componentWillReceiveProps: function componentWillReceiveProps(newProps) {
    var state = newProps.state;

    if (state !== this.state.carouselStep) {
      this.setState({
        carouselStep: state
      });
    }

    if (!this.props.dyno.legalConsentOptions && newProps.dyno.legalConsentOptions) {
      this.setState({
        gdprStep: 0
      });
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.setUpInterval();
  },
  componentWillUnmount: function componentWillUnmount() {
    window.clearInterval(stepInterval);
  },
  setUpInterval: function setUpInterval() {
    window.clearInterval(stepInterval);

    if (this.props.interactionDisabled || this.state.carouselStopped) {
      return;
    }

    stepInterval = window.setInterval(this.advanceStep, CAROUSEL_INTERVAL);
  },
  advanceStep: function advanceStep() {
    var states = Object.keys(_DynoEditor.PREVIEW_DYNO_STATES || {});
    var currentIndex = states.indexOf(this.state.carouselStep);
    var isLastIndex = currentIndex === states.length - 1;
    var nextIndex = isLastIndex ? 0 : currentIndex + 1;
    this.setState({
      carouselStep: states[nextIndex]
    });
  },
  changeGDRPStep: function changeGDRPStep(newStep) {
    this.setState({
      gdprStep: newStep
    });
  },
  changeCarouselStepManually: function changeCarouselStepManually(newStep) {
    this.setState({
      carouselStep: newStep,
      carouselStopped: true
    });
  },
  handleDynoStateChange: function handleDynoStateChange(newState) {
    if (newState === this.state.carouselStep) {
      return;
    }

    this.changeCarouselStepManually(newState);
  },
  renderCarouselSteps: function renderCarouselSteps() {
    var _this$props = this.props,
        dyno = _this$props.dyno,
        step = _this$props.step,
        hasForm = _this$props.hasForm;
    var gdprStep = this.state.gdprStep;
    var activeStep = Object.keys(_DynoEditor.PREVIEW_DYNO_STATES || {}).indexOf(this.state.carouselStep);
    var isFormWithGDPR = Boolean(step === _DynoEditor.STEPS.FORM && dyno.legalConsentOptions);
    var interactionDisabled = this.props.interactionDisabled && !isFormWithGDPR;

    if (interactionDisabled) {
      return null;
    }

    return _react.default.createElement(_DynoPreviewCarouselSteps.default, {
      ref: "carouselSteps",
      hasForm: hasForm,
      activeStep: activeStep,
      changeStep: this.changeCarouselStepManually,
      changeGDRPStep: this.changeGDRPStep,
      gdprStep: gdprStep,
      isFormWithGDPR: isFormWithGDPR
    });
  },
  renderIframe: function renderIframe() {
    var _this$props2 = this.props,
        dyno = _this$props2.dyno,
        state = _this$props2.state,
        step = _this$props2.step,
        interactionDisabled = _this$props2.interactionDisabled,
        hasForm = _this$props2.hasForm;
    var _this$state = this.state,
        carouselStep = _this$state.carouselStep,
        gdprStep = _this$state.gdprStep;
    var previewState = state;

    if (!interactionDisabled) {
      previewState = carouselStep;
    }

    if (!hasForm) {
      previewState = 'PREVIEW';
    }

    return _react.default.createElement(_DynoEditorDemoIframe.default, {
      dyno: dyno,
      gdprStep: gdprStep,
      handleGDPRChange: this.changeGDRPStep,
      handleStateChange: this.handleDynoStateChange,
      interactionDisabled: interactionDisabled,
      state: previewState,
      step: step
    });
  },
  render: function render() {
    var content = this.renderIframe();
    return _react.default.createElement("div", {
      className: "dyno-editor-side-preview"
    }, _react.default.createElement(_UIDeviceFrame.default, {
      className: "dyno-editor-demo-iframe-container",
      contentClassName: "dyno-editor-demo-iframe"
    }, content), this.renderCarouselSteps());
  }
});

exports.default = _default;
module.exports = exports.default;